export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function exportar(documento_uuid) {
  const externalUrl = `${BACKEND_URL}/api/exportar/${documento_uuid}`;
  window.open(externalUrl, '_blank', 'noopener,noreferrer');
}
